import Image from "next/image"
import { IoMdClose } from "react-icons/io"
import {
    FiArrowUpLeft,
    FiArrowUpRight,
    FiChevronLeft,
    FiChevronRight,
    FiCornerDownLeft,
    FiCornerDownRight,
} from "react-icons/fi"
import { NAV_MAIN_LIST } from "./NewNavbar"
import { useTheme } from "next-themes"
import { useUserContext } from "context/UserContext"
import { useLang } from "hooks/useLang"
import { useRouter } from "next/router"
import { motion } from "framer-motion"

interface IProps {
    isMenuOpen?: boolean
    setIsMenuOpen: (value: boolean) => void
}

const MobileMenu = ({ setIsMenuOpen }: IProps) => {
    const { theme, setTheme } = useTheme()

    const isDark = theme === "dark"

    const { user, logout } = useUserContext()
    const { isAr, changeLanguage, t } = useLang()
    const { push } = useRouter()

    const navigate = (to: string) => {
        setIsMenuOpen(false)
        push(to)
    }

    return (
        <motion.div
            initial={{ opacity: 0, x: isAr ? "-100%" : "100%" }}   // left if Arabic, right if English
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: isAr ? "-100%" : "100%" }}      // slide back out the same way
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className={`fixed top-0 z-[999] h-screen w-full bg-white bg-opacity-60 backdrop-blur-xl dark:bg-[#595959] dark:bg-opacity-20 md:hidden 
    ${isAr ? "left-0" : "right-0"}`}
        >
            <div className="relative flex h-full flex-col gap-7 p-4 py-5">
                <div className="flex items-center justify-between">
                    <div />
                    <IoMdClose
                        size={40}
                        onClick={() => setIsMenuOpen(false)}
                        className="cursor-pointer"
                    />
                </div>
                <div
                    onClick={() =>
                        user
                            ? navigate("/user/profile/account")
                            : navigate("/user/login")
                    }
                    className="flex cursor-pointer items-center justify-between">
                    <div className="flex flex-col">
                        <span className="font-medium capitalize">
                            {t("menu_welcome")}
                        </span>
                        <span className="text-xl font-semibold capitalize text-primary-theme-400 dark:text-action-theme-100">
                            {user
                                ? user?.first_name + " " + user?.last_name
                                : t("welcome_guest")}
                        </span>
                    </div>
                    {isAr ? (
                        <FiChevronLeft size={20} />
                    ) : (
                        <FiChevronRight size={20} />
                    )}
                </div>

                <div className="flex flex-col gap-5 pb-10 capitalize">
                    {NAV_MAIN_LIST.map((item, index: number) => (
                        <div
                            key={index}
                            onClick={() => navigate(item.linkTo)}
                            className="flex cursor-pointer items-center justify-between border-b border-primary-theme-100 py-2">
                            <div className="flex flex-col">
                                <span className="text-base font-semibold text-primary-theme-400 dark:text-white">
                                    {t(item.title)}
                                </span>
                            </div>
                            {isAr ? (
                                <FiArrowUpLeft size={20} />
                            ) : (
                                <FiArrowUpRight size={20} />
                            )}
                        </div>
                    ))}
                    <div
                        onClick={() => changeLanguage()}
                        className="flex cursor-pointer items-center justify-between border-b border-primary-theme-100 py-2">
                        <div className="flex flex-col">
                            <span className="text-base font-semibold text-primary-theme-400 dark:text-white">
                                {t("language")}
                            </span>
                        </div>
                        <span className="font-semibold text-action-theme-400 dark:text-action-theme-100">
                            {isAr ? "English" : "عربي"}
                        </span>
                    </div>
                </div>

                {/* <div className="flex items-center justify-between">
                    <div className="capitalize text-black dark:text-white">
                        {isDark ? `${t("light_mode")}` : `${t("dark_mode")}`}
                    </div>
                    <div
                        onClick={() => setTheme(isDark ? "light" : "dark")}
                        className="relative h-[28px] w-[55px] cursor-pointer overflow-hidden rounded-full bg-primary-theme-500 transition-all delay-500 duration-500 dark:bg-warning-theme-200">
                        <FiSun
                            color="white"
                            className={`absolute right-1 top-1/2 -translate-y-1/2 transition-all duration-500 ${!isDark
                                    ? "translate-x-5 rotate-180 opacity-0"
                                    : "translate-x-0 rotate-0 opacity-100"
                                }`}
                        />
                        <FiMoon
                            color="white"
                            className={`absolute left-1 top-1/2 -translate-y-1/2 transition-all duration-500 ${isDark
                                    ? "-translate-x-5 rotate-180 opacity-0"
                                    : "translate-x-0 rotate-0 opacity-100"
                                }`}
                        />
                    </div>
                </div> */}

                {user ? (
                    <div
                        onClick={logout}
                        className="flex cursor-pointer items-center gap-2 capitalize text-action-theme-400 dark:text-action-theme-100">
                        {isAr ? <FiCornerDownRight /> : <FiCornerDownLeft />}
                        <div>{t("logout")}</div>
                    </div>
                ) : (
                    <div className="flex items-center justify-between">
                        <div
                            onClick={() => navigate("/user/login")}
                            className="flex cursor-pointer items-center gap-2 capitalize text-action-theme-400 dark:text-action-theme-100">
                            {isAr ? (
                                <FiCornerDownRight />
                            ) : (
                                <FiCornerDownLeft />
                            )}
                            <div>{t("Sign_in")}</div>
                        </div>
                        <div
                            onClick={() => navigate("/user/signup")}
                            className="flex cursor-pointer items-center gap-2 capitalize text-action-theme-400 dark:text-action-theme-100">
                            {isAr ? (
                                <FiCornerDownRight />
                            ) : (
                                <FiCornerDownLeft />
                            )}
                            <div>{t("Create_account")}</div>
                        </div>
                    </div>
                )}
            </div>
        </motion.div>
    )
}

export default MobileMenu
